const RecentTransfers = (function() {
    'use strict';

    let updateInterval = null;
    const MAX_TRANSFERS = 10;

    function ensureTranslations() {
        if (!window.TRANSFERS_TRANSLATIONS) {
            window.TRANSFERS_TRANSLATIONS = {
                'loading': 'Ładowanie...',
                'no_transfers': 'Brak ostatnich przekazów',
                'error_loading': 'Błąd ładowania danych',
                'transfer': 'przekaz',
                'to': 'do'
            };
        }
    }

    function init() {
        ensureTranslations();

        loadTransfers();

        updateInterval = setInterval(function() {
            loadTransfers();
        }, 30000);
    }

    function loadTransfers() {
        showLoadingState();

        fetch('/ajax', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: 'loadTransactions=1'
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {

                if (Array.isArray(data) && data.length > 0) {
                    const limitedData = data.slice(0, MAX_TRANSFERS);
                    displayTransfers(limitedData);
                } else {
                    showEmptyState();
                }
            })
            .catch(error => {
                showErrorState();
            });
    }

    function showLoadingState() {
        const container = document.querySelector('.transfers-list ul');
        if (!container) return;

        const loadingText = getTranslation('loading', 'Ładowanie...');

        container.innerHTML = `
            <li class="loading-state">
                <span class="transfer-time">--:--</span>
                <span class="transfer-desc">${loadingText}</span>
            </li>
        `;
    }

    function showEmptyState() {
        const container = document.querySelector('.transfers-list ul');
        if (!container) return;

        const emptyText = getTranslation('no_transfers', 'Brak ostatnich przekazów');

        container.innerHTML = `
            <li class="empty-state">
                <span class="transfer-desc">${emptyText}</span>
            </li>
        `;
    }

    function showErrorState() {
        const container = document.querySelector('.transfers-list ul');
        if (!container) return;

        const errorText = getTranslation('error_loading', 'Błąd ładowania danych');

        container.innerHTML = `
            <li class="error-state">
                <span class="transfer-desc">${errorText}</span>
            </li>
        `;
    }

    function displayTransfers(transfers) {
        const container = document.querySelector('.transfers-list ul');
        if (!container) {
            return;
        }

        container.innerHTML = '';

        transfers.forEach(transfer => {
            const li = createTransferElement(transfer);
            container.appendChild(li);
        });
    }

    function createTransferElement(transfer) {
        const li = document.createElement('li');

        const timeSpan = document.createElement('span');
        timeSpan.className = 'transfer-time';
        timeSpan.textContent = transfer.time || '--:--';
        li.appendChild(timeSpan);

        if (transfer.currency) {
            const flag = document.createElement('img');
            const flagFile = transfer.currency.toLowerCase();
            flag.src = `/assets/images/flags/${flagFile}.svg`;
            flag.alt = transfer.currency_name || transfer.currency;
            flag.className = 'flag';
            flag.onerror = function() {
                console.warn(`Flag not found: ${flagFile}.svg`);
                this.style.display = 'none';
            };
            li.appendChild(flag);
        }

        const descSpan = document.createElement('span');
        descSpan.className = 'transfer-desc';

        const transferText = getTranslation('transfer', 'przekaz');
        const toText = getTranslation('to', 'do');
        const formattedAmount = formatAmount(transfer.amount);
        const currency = transfer.currency || '';

        // Sprawdzamy czy kraj istnieje i nie jest pusty
        const countryName = transfer.country || '';
        const translatedCountry = translateCountry(countryName);

        // Budujemy tekst opisu w zależności od tego czy mamy kraj
        let description = `${transferText} ${formattedAmount} ${currency}`;

        // Dodajemy "do [kraj]" tylko jeśli kraj istnieje i nie jest pusty
        if (countryName && countryName.trim() !== '') {
            description += ` ${toText} ${translatedCountry}`;
        }

        descSpan.textContent = description;
        li.appendChild(descSpan);

        return li;
    }

    function translateCountry(countryName) {
        if (!countryName) return '';

        const countryTranslations = {
            'Polska': 'Poland',
            'Anglia': 'England',
            'Wielka Brytania': 'Great Britain',
            'Niemcy': 'Germany',
            'Francja': 'France',
            'Włochy': 'Italy',
            'Hiszpania': 'Spain',
            'USA': 'USA',
            'Kanada': 'Canada',
            'Australia': 'Australia',
            'Irlandia': 'Ireland',
            'Holandia': 'Netherlands',
            'Belgia': 'Belgium',
            'Szwecja': 'Sweden',
            'Norwegia': 'Norway',
            'Dania': 'Denmark',
            'Finlandia': 'Finland',
            'Szwajcaria': 'Switzerland',
            'Austria': 'Austria',
            'Czechy': 'Czech Republic',
            'Słowacja': 'Slovakia',
            'Węgry': 'Hungary',
            'Rumunia': 'Romania',
            'Bułgaria': 'Bulgaria',
            'Grecja': 'Greece',
            'Portugalia': 'Portugal',
            'Chiny': 'China',
            'Japonia': 'Japan',
            'Korea Południowa': 'South Korea',
            'Indie': 'India',
            'Brazylia': 'Brazil',
            'Meksyk': 'Mexico',
            'Argentyna': 'Argentina',
            'Chile': 'Chile',
            'Południowa Afryka': 'South Africa',
            'Egipt': 'Egypt',
            'Turcja': 'Turkey',
            'Ukraina': 'Ukraine',
            'Rosja': 'Russia',
            'Białoruś': 'Belarus',
            'Litwa': 'Lithuania',
            'Łotwa': 'Latvia',
            'Estonia': 'Estonia'
        };

        if (window.CURRENT_LANGUAGE === 'en' && countryTranslations[countryName]) {
            return countryTranslations[countryName];
        }

        return countryName;
    }

    function getTranslation(key, fallback) {
        if (window.TRANSFERS_TRANSLATIONS && window.TRANSFERS_TRANSLATIONS[key]) {
            return window.TRANSFERS_TRANSLATIONS[key];
        }
        return fallback;
    }

    function formatAmount(amount) {
        if (!amount) return '0.00';

        let cleaned = amount.toString().replace(/\s/g, '').replace(/,/g, '.');
        let number = parseFloat(cleaned);

        if (isNaN(number)) return amount;

        const language = window.CURRENT_LANGUAGE || 'pl';
        const locale = language === 'en' ? 'en-US' : 'pl-PL';

        return number.toLocaleString(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true
        });
    }

    function stop() {
        if (updateInterval) {
            clearInterval(updateInterval);
            updateInterval = null;
        }
    }

    function refresh() {
        loadTransfers();
    }

    function getMaxTransfers() {
        return MAX_TRANSFERS;
    }

    function setLanguage(lang) {
        window.CURRENT_LANGUAGE = lang;
        refresh();
    }

    return {
        init: init,
        refresh: refresh,
        stop: stop,
        getMaxTransfers: getMaxTransfers,
        setLanguage: setLanguage
    };
})();

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(RecentTransfers.init, 100);
    });
} else {
    setTimeout(RecentTransfers.init, 100);
}